module.exports = __webpack_public_path__ + "static/bg.767716f0.png";